import { render, staticRenderFns } from "./Managers.vue?vue&type=template&id=5342c9b0&scoped=true&"
import script from "./Managers.vue?vue&type=script&lang=ts&"
export * from "./Managers.vue?vue&type=script&lang=ts&"
import style0 from "./Managers.vue?vue&type=style&index=0&id=5342c9b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5342c9b0",
  null
  
)

export default component.exports